"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
var dashjs_1 = require("dashjs");
var DashEvents = dashjs_1.MediaPlayer['events'];
var DashStream = (function () {
    function DashStream(mediaStreams, emit) {
        var _this = this;
        this.emit = emit;
        this.dashPlayer = null;
        this.mediaStream = null;
        this.onError = function (errorEvent) {
            if (!errorEvent) {
                return;
            }
            if (errorEvent.error === 'manifestError' || (errorEvent.error === 'download' && errorEvent.event.id === 'manifest')) {
                _this.emit('error', types_1.Errors.SRC_LOAD_ERROR, _this.mediaStream && _this.mediaStream.url, errorEvent);
            }
        };
        this.onStreamInitialized = function () {
            _this.emit('levels', _this.getMediaLevels());
        };
        if (mediaStreams.length === 1) {
            this.mediaStream = mediaStreams[0];
        }
        else {
            throw new Error("Vidi can only handle a single DASH stream. Received " + mediaStreams.length + " streams.");
        }
    }
    DashStream.prototype.attach = function (videoElement, initialBitrate) {
        if (!this.mediaStream) {
            return;
        }
        this.dashPlayer = dashjs_1.MediaPlayer().create();
        this.dashPlayer.getDebug().setLogToBrowserConsole(false);
        this.dashPlayer.on(DashEvents.STREAM_INITIALIZED, this.onStreamInitialized);
        this.dashPlayer.on(DashEvents.ERROR, this.onError);
        this.dashPlayer.initialize(videoElement, this.mediaStream.url, videoElement.autoplay);
        if (initialBitrate) {
            this.dashPlayer.setInitialBitrateFor('video', initialBitrate);
        }
    };
    DashStream.prototype.detach = function (videoElement) {
        if (!this.mediaStream) {
            return;
        }
        this.dashPlayer.reset();
        this.dashPlayer.off(DashEvents.STREAM_INITIALIZED, this.onStreamInitialized);
        this.dashPlayer.off(DashEvents.ERROR, this.onError);
        this.dashPlayer = null;
    };
    DashStream.prototype.getMediaStreamDeliveryType = function () {
        return types_1.MediaStreamDeliveryType.ADAPTIVE_VIA_MSE;
    };
    DashStream.prototype.setMediaLevel = function (newLevel, videoElement) {
        // TODO
    };
    DashStream.prototype.getMediaLevels = function () {
        if (!this.dashPlayer) {
            return [];
        }
        var bitrates = this.dashPlayer.getBitrateInfoListFor('video') || [];
        return bitrates.map(function (bitrateInfo) {
            return { bitrate: bitrateInfo.bitrate, width: bitrateInfo.width, height: bitrateInfo.height };
        });
    };
    DashStream.isSupported = function (env) {
        return env.MSE;
    };
    ;
    DashStream.canPlay = function (mediaType) {
        return mediaType === types_1.MediaStreamTypes.DASH;
    };
    return DashStream;
}());
exports.DashStream = DashStream;
//# sourceMappingURL=dash-stream.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/media-streams/playable-streams/dash-stream.js
// module id = 1513
// module chunks = 0 1 2 3